export const MAIN_AWS_ACCOUNT = '594012563756';
export const DEV_AWS_ACCOUNT = '677276077816';
export const UAT_AWS_ACCOUNT = '677276077816';
export const PROD_AWS_ACCOUNT = '';
export const DEV_PLATFORM_AWS_ACCOUNT = '225989332653';
export const UAT_PLATFORM_AWS_ACCOUNT = '225989332653';
export const MAIN_PLATFORM_AWS_ACCOUNT = '565393035894';
export const PROD_PLATFORM_AWS_ACCOUNT = '';
export const MAIN_AWS_REGION = 'us-east-1';
export const ROOT_SAAS_DOMAIN = 'saas.platform.joinscaleup.com';
export const ROOT_PLATFORM_DOMAIN = 'platform.joinscaleup.com';
export const DEV_ROOT_PLATFORM_DOMAIN = 'dev.app.joinscaleup.com';
export const UAT_ROOT_PLATFORM_DOMAIN = 'uat.app.joinscaleup.com';
export const ROOT_MAIN_PLATFORM_DOMAIN = 'platform.joinscaleup.com';
export const DEV_SAAS_DOMAIN = 'dev.saas.joinscaleup.com';
export const UAT_SAAS_DOMAIN = 'uat.saas.joinscaleup.com';
export const SRA_KEY = 'ASSESS_45fe662222bb4cd8acdb1b5c9c86fd60';
export const ROOT_DOMAIN_CERT_ARN =
  'arn:aws:acm:us-east-1:677276077816:certificate/88ff227b-f30f-4118-80ff-eccf0191ee72';
export const ROOT_PLATFORM_DOMAIN_CERT_ARN =
  'arn:aws:acm:us-east-1:225989332653:certificate/bdc0b3cb-d136-4849-8634-3df34c14f015';
export const GITHUB_CONNECTION =
  'arn:aws:codeconnections:us-east-1:594012563756:connection/bf432ec5-2e15-4a63-95b9-60733419933a';
